import React from 'react'

const Layout: React.FC = () => {
  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173 184H211C215.986 184 219.977 186.983 218.552 191.957C205.386 229.266 169.815 256 128 256C74.9807 256 32 213.019 32 160C32 106.981 74.9807 64 128 64C169.815 64 205.386 90.7342 218.552 128.043C219.977 133.017 215.986 136 211 136H173C170.578 136 169.459 135.406 168.7 134.542C168.277 133.867 167.838 133.204 167.383 132.552C167.265 132.369 167.138 132.185 167 132H166.992C158.278 119.887 144.06 112 128 112C101.49 112 80 133.49 80 160C80 186.51 101.49 208 128 208C144.06 208 158.278 200.113 166.992 188H167C167.138 187.815 167.265 187.631 167.383 187.448C167.838 186.796 168.277 186.133 168.7 185.458C169.459 184.594 170.578 184 173 184Z"
        fill="#40ABF2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173 184H211C215.986 184 219.977 186.983 218.552 191.957C205.386 229.266 169.815 256 128 256C74.9807 256 32 213.019 32 160C32 106.981 74.9807 64 128 64C169.815 64 205.386 90.7342 218.552 128.043C219.977 133.017 215.986 136 211 136H173C170.578 136 169.459 135.406 168.7 134.542C168.277 133.867 167.838 133.204 167.383 132.552C167.265 132.369 167.138 132.185 167 132H166.992C158.278 119.887 144.06 112 128 112C101.49 112 80 133.49 80 160C80 186.51 101.49 208 128 208C144.06 208 158.278 200.113 166.992 188H167C167.138 187.815 167.265 187.631 167.383 187.448C167.838 186.796 168.277 186.133 168.7 185.458C169.459 184.594 170.578 184 173 184Z"
        fill="url(#paint0_angular)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152 176L152 48H216C220.418 48 224 44.4183 224 40V8C224 3.58172 220.418 2.09815e-06 216 2.09815e-06H152L104 0L40 2.09815e-06C35.5817 2.09815e-06 32 3.58173 32 8V40C32 44.4183 35.5817 48 40 48H104L104 176C104 180.418 107.582 184 112 184H144C148.418 184 152 180.418 152 176Z"
        fill="url(#paint1_linear)"
      />
      <defs>
        <radialGradient
          id="paint0_angular"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(128 160) scale(96.0248 93.0234)"
        >
          <stop offset="0.0312318" stopColor="#2C91D5" />
          <stop offset="0.968253" stopColor="#2AA1F1" />
        </radialGradient>
        <linearGradient
          id="paint1_linear"
          x1="128"
          y1="0"
          x2="128"
          y2="184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1270AF" />
          <stop offset="1" stopColor="#3D82B1" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Layout
